export const backgroundImage = 'https://static.meucupom.com/media/LP%20-%20Clube%20de%20beneficio/bg-body.png'; 
export const logoImage = 'https://static.meucupom.com/media/LP%20-%20Clube%20de%20beneficio/logo-header.png';